// extracted by mini-css-extract-plugin
export default {"title":"common-configurable-wizards-WizardProgressBar__title--l5LT3"};